import Login from "./components/Login/index";
import TimeSlots from "./components/TimeSlots";
import App from "./App";
import { Route, Routes as RouterDomRoutes, Navigate } from "react-router-dom";
import CarLocationComponent from "./components/CarLocationComponent";
import ProtectedRoute from "$api/ProtectedRoute";
import { useAuth } from "$context/AuthContextProvider";

export const Routes = () => {
  const { isAuthenticated, isAdmin, bearerToken } = useAuth();
  
  const getDefaultRoute = () => {
    return !isAuthenticated ? "/login" : (isAdmin ? "/agent_home" : "/location_home");
  };
  
  return (
    <RouterDomRoutes>
      <Route path="/" element={<Navigate to={getDefaultRoute()} replace />} />
      <Route 
        path="/login" 
        element={
          isAuthenticated ? <Navigate to={getDefaultRoute()} replace /> : <Login />
        } 
      />
      <Route element={<ProtectedRoute />}>
        <Route path="/agent_home" element={<App content={<TimeSlots />} />} />
        <Route
          path="/location_home"
          element={<App content={<CarLocationComponent />} />}
        />
      </Route>
    </RouterDomRoutes>
  );
};
